import {createBrowserRouter, Navigate, Outlet} from "react-router-dom";
import App from "../App";
import HomePage from "../pages/home-page";
import LoginPage from "../pages/login-page";
import DashboardPage from "../pages/dashboard-page";
import ProtectedRoute from "./protected-route";
import {AdminRoute} from "./admin-route";
import UsersPage from "../pages/admin/users/users-page.tsx";
import EditUserPage from "../pages/admin/users/edit-user-page.tsx";
import NewUserPage from "../pages/admin/users/new-user-page.tsx";
import Error from "../components/error.tsx";
import MemberListPage from "@/pages/members/member-list-page.tsx";
import NewMemberPage from "@/pages/members/new-member-page.tsx";
import MemberDetailsPage from "@/pages/members/details/member-details-page.tsx";
import MemberPointsStatementPage from "@/pages/members/points-statement/member-points-statement-page.tsx";
import MemberRetainedDataPage from "@/pages/members/retained-data/member-retained-data-page.tsx";
import SpecialAssignmentsPage from "@/pages/members/special-assignments-page.tsx";
import OrdersOpenPage from "@/pages/orders/orders-open-page.tsx";
import OrdersCompletedPage from "@/pages/orders/orders-completed-page.tsx";
import OrdersCancelledPage from "@/pages/orders/orders-cancelled-page.tsx";
import OrderDetailsPage from "@/pages/orders/order-details-page.tsx";
import ServiceListPage from "@/pages/admin/services/service-list-page.tsx";
import AdminSettingsPage from "@/pages/admin/settings/admin-settings-page.tsx";
import DistrictStreetsPage from "@/pages/admin/settings/district-streets-page.tsx";
import AdminAuditLogPage from "@/pages/admin/audit-log/admin-audit-log-page.tsx";
import AdminEmailSendLogPage from "@/pages/admin/email-send-log/admin-email-send-log-page.tsx";
import CreateOrderPage from "@/pages/orders/create-order-page.tsx";
import LedgerPage from "@/pages/ledger-page.tsx";
import BillingOverviewPage from "@/pages/finance/billing/billing-overview-page.tsx";
import BillingRunDetailPage from "@/pages/finance/billing/billing-run-detail-page.tsx";
import SocialAccountStatementPage from "@/pages/finance/social-account/social-account-statement-page.tsx";
import BirthdayListPage from "@/pages/reports/birthdays/birthday-list-page.tsx";
import DriverListPage from "@/pages/reports/drivers/driver-list-page.tsx";
import FormerMemberListPage from "@/pages/reports/former-members/former-member-list-page.tsx";
import BankDataValidationListPage from "@/pages/reports/bank-data-validation/bank-data-validation-list-page.tsx";
import MemberAddressListPage from "@/pages/reports/address-list/member-address-list-page.tsx";
import MemberPhoneListPage from "@/pages/reports/phone-list/member-phone-list-page.tsx";
import StatisticsPage from "@/pages/reports/statistics/statistics-page.tsx";
import MaintenancePage from "@/pages/maintenance-page.tsx";
import PasswordResetRequestPage from "@/pages/password-reset-request-page.tsx";
import PasswordResetConfirmPage from "@/pages/password-reset-confirm-page.tsx";
import EmailVerificationConfirmPage from "@/pages/email-verification-confirm-page.tsx";

export const routes = createBrowserRouter([
    {
        path: "/",
        element: <App/>,
        children: [
            {path: "", element: <HomePage/>},
            {path: "login", element: <LoginPage/>},
            {path: "maintenance", element: <MaintenancePage/>},
            {path: "password-reset", element: <PasswordResetRequestPage/>},
            {path: "password-reset/confirm", element: <PasswordResetConfirmPage/>},
            {path: "email-verification/confirm", element: <EmailVerificationConfirmPage/>},
            {
                path: "dashboard",
                element:
                    <ProtectedRoute>
                        <DashboardPage/>
                    </ProtectedRoute>
            },
            {
                path: "members",
                element: <ProtectedRoute><Outlet/></ProtectedRoute>,
                children: [
                    {
                        path: "",
                        element: <MemberListPage/>
                    },
                    {
                        path: "new",
                        element: <NewMemberPage/>

                    },
                    {
                        path: "special-assignments",
                        element: <SpecialAssignmentsPage/>
                    },
                    {
                        path: ":memberId/points-statement",
                        element: <MemberPointsStatementPage/>
                    },
                    {
                        path: ":memberId/retained-data",
                        element: <MemberRetainedDataPage/>
                    },
                    {
                        path: ":memberId",
                        element: <MemberDetailsPage/>

                    }
                ]
            },
            {
                path: "orders",
                element: <ProtectedRoute><Outlet/></ProtectedRoute>,
                children: [
                    {
                        path: "",
                        element: <Navigate to="/orders/open" replace />
                    },
                    {
                        path: "open",
                        element: <OrdersOpenPage/>
                    },
                    {
                        path: "completed",
                        element: <OrdersCompletedPage/>
                    },
                    {
                        path: "cancelled",
                        element: <OrdersCancelledPage/>
                    },
                    {
                        path: "new",
                        element: <CreateOrderPage/>
                    },
                    {
                        path: ":orderId",
                        element: <OrderDetailsPage/>

                    }
                ]
            },
            {
                path: "ledger",
                element: <ProtectedRoute><LedgerPage/></ProtectedRoute>
            },
            {
                path: "finance",
                element: <ProtectedRoute><Outlet/></ProtectedRoute>,
                children: [
                    {
                        path: "billing",
                        element: <BillingOverviewPage/>
                    },
                    {
                        path: "billing/runs/:id",
                        element: <BillingRunDetailPage/>
                    },
                    {
                        path: "social-account",
                        element: <SocialAccountStatementPage/>
                    }
                ]
            },
            {
                path: "reports",
                element: <ProtectedRoute><Outlet/></ProtectedRoute>,
                children: [
                    {
                        path: "birthdays",
                        element: <BirthdayListPage/>
                    },
                    {
                        path: "drivers",
                        element: <DriverListPage/>
                    },
                    {
                        path: "former-members",
                        element: <FormerMemberListPage/>
                    },
                    {
                        path: "bank-data-validation",
                        element: <BankDataValidationListPage/>
                    },
                    {
                        path: "address-list",
                        element: <MemberAddressListPage/>
                    },
                    {
                        path: "phone-list",
                        element: <MemberPhoneListPage/>
                    },
                    {
                        path: "statistics",
                        element: <StatisticsPage/>
                    }
                ]
            },
            {
                path: "admin",
                element: <AdminRoute/>,
                children: [
                    {
                        path: "users",
                        element: <UsersPage/>,
                    },
                    {
                        path: "users/new",
                        element: <NewUserPage/>
                    },
                    {
                        path: "users/:userId",
                        element: <EditUserPage/>
                    },
                    {
                        path: "services",
                        element: <ServiceListPage/>
                    },
                    {
                        path: "settings",
                        element: <AdminSettingsPage/>
                    },
                    {
                        path: "settings/district-streets",
                        element: <DistrictStreetsPage/>
                    },
                    {
                        path: "audit-log",
                        element: <AdminAuditLogPage/>
                    },
                    {
                        path: "email-send-log",
                        element: <AdminEmailSendLogPage/>
                    },

                ]
            },
            {
                path: "*",
                element: <Error/>
            }
        ]
    },

])
